import { report } from '@/api/report';
import { useGlobalInfoStore } from '@/stores/Global';

export enum REPORT_EVENT_NAME {
  ORIGIN_README = 'origin-readme',
  AIGC_README = 'aigc-readme',
  CHAT_TTS = 'chat-tts',
}

export const useReport = async (eventID: string, eventParams: object, headers?: object) => {
  // 百度pv手动上报
  if (eventID === 'pageview' && window._hmt) {
    const path = window.location.pathname + window.location.search;
    window._hmt.push(['_trackPageview', path]);
  }
  const globalStore = useGlobalInfoStore();
  if (globalStore.httpStatus !== 200) { // 只上报错误状态码
    eventParams.http_code = globalStore.httpStatus;
  }
  return await report(eventID, eventParams, headers);
};
